import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import InputMask from 'react-input-mask';

export type MaskType = 
  | 'phone' 
  | 'cnpj' 
  | 'cpf' 
  | 'cep' 
  | 'date' 
  | 'time' 
  | 'rg' 
  | 'custom';

interface MaskedTextFieldProps extends Omit<TextFieldProps, 'InputProps'> {
  maskType: MaskType;
  customMask?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const getMask = (maskType: MaskType, customMask?: string): string => {
  const masks = {
    phone: '(99) 99999-9999',
    cnpj: '99.999.999/9999-99',
    cpf: '999.999.999-99',
    cep: '99999-999',
    date: '99/99/9999',
    time: '99:99',
    rg: '99.999.999-9',
    custom: customMask || ''
  };

  return masks[maskType];
};

const getPlaceholder = (maskType: MaskType): string => {
  const placeholders = {
    phone: '(11) 99999-9999',
    cnpj: '12.345.678/0001-90',
    cpf: '123.456.789-00',
    cep: '12345-678',
    date: 'DD/MM/AAAA',
    time: 'HH:MM',
    rg: '12.345.678-9',
    custom: ''
  };

  return placeholders[maskType];
};

export const MaskedTextField: React.FC<MaskedTextFieldProps> = ({
  maskType,
  customMask,
  value,
  onChange,
  placeholder,
  ...textFieldProps
}) => {
  const mask = getMask(maskType, customMask);
  const defaultPlaceholder = placeholder || getPlaceholder(maskType);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      const unmaskedValue = event.target.value.replace(/[^0-9]/g, '');

      const syntheticEvent = {
        ...event,
        target: {
          ...event.target,
          value: unmaskedValue,
          name: event.target.name
        }
      };
      onChange(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <InputMask
      mask={mask}
      value={value || ''}
      onChange={handleChange}
      maskChar="_"
    >
      {(inputProps: any) => (
        <TextField
          {...textFieldProps}
          {...inputProps}
          placeholder={defaultPlaceholder}
        />
      )}
    </InputMask>
  );
};

export default MaskedTextField;